export const NOTIFICATION_TEST_IDS = {
  item: {
    mentionIcon: 'notification.item.view.mentionIcon',
    unreadDot: 'notification.item.view.unreadDot',
  },
} as const;
